import React, { useState } from 'react';
import './Part.scss';
import { PART_STATUS, STATUS_TEXT, PartStatus } from '../../constants/PartsConstants';
import { AogPartDetails } from '../../Models/Orderpart';


interface PartProps {
  partData: AogPartDetails;
  isExpandable?: boolean;
  defaultExpanded?: boolean;
}

const Part: React.FC<PartProps> = ({
  partData,
  isExpandable = true,
  defaultExpanded = false
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    if (isExpandable) {
      setIsExpanded(!isExpanded);
    }
  };

  const getStatusClass = (status: PartStatus) => {
    switch (status) {
      case PART_STATUS.REQUESTED:
        return 'status-requested';
      case PART_STATUS.ARRIVING:
        return 'status-arriving';
      case PART_STATUS.CANCELLED:
        return 'status-cancelled';
      case PART_STATUS.DELIVERED:
        return 'status-delivered';
      default:
        return 'status-requested';
    }
  };

  const statusText = partData.StatusText || STATUS_TEXT[partData.Status as PartStatus] || '';

  const ChevronUpIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M14.6704 12.0388L14.6099 12.1089C14.388 12.3308 14.0408 12.351 13.7961 12.1694L13.726 12.1089L10.0013 8.38449L6.27658 12.1089C6.05469 12.3308 5.70747 12.351 5.46279 12.1694L5.39269 12.1089C5.17081 11.887 5.15063 11.5398 5.33218 11.2951L5.39269 11.225L9.11714 7.50033L9.2942 7.32327C9.68472 6.93274 10.3179 6.93274 10.7084 7.32327L10.8855 7.50033L14.6099 11.2251C14.8318 11.4469 14.852 11.7942 14.6704 12.0388L14.6099 12.1089L14.6704 12.0388Z" fill="#00274A" fillOpacity="0.65"/>
    </svg>
  );

  const ChevronDownIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ transform: 'rotate(180deg)' }}>
      <path fillRule="evenodd" clipRule="evenodd" d="M14.6704 12.0388L14.6099 12.1089C14.388 12.3308 14.0408 12.351 13.7961 12.1694L13.726 12.1089L10.0013 8.38449L6.27658 12.1089C6.05469 12.3308 5.70747 12.351 5.46279 12.1694L5.39269 12.1089C5.17081 11.887 5.15063 11.5398 5.33218 11.2951L5.39269 11.225L9.11714 7.50033L9.2942 7.32327C9.68472 6.93274 10.3179 6.93274 10.7084 7.32327L10.8855 7.50033L14.6099 11.2251C14.8318 11.4469 14.852 11.7942 14.6704 12.0388L14.6099 12.1089L14.6704 12.0388Z" fill="#00274A" fillOpacity="0.65"/>
    </svg>
  );

  return (
    <div className="part-component">
      <div 
        className={`part-header ${isExpandable ? 'expandable' : ''}`}
        onClick={toggleExpanded}
      >
        <div className="part-info">
          <span className="part-title">
            {partData.PartNumber} - {partData.Description}
            {partData.Quantity !== undefined && ` (${partData.Quantity})`}
          </span>
        </div>
        <div className="part-status-container">
          <span className={`part-status ${getStatusClass(partData.Status as PartStatus)}`}>
            {statusText}
          </span>
          {isExpandable && (
            <div className="chevron-icon">
              {isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
            </div>
          )}
        </div>
      </div>
      
      {isExpandable && (
  <div className={`part-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
    <div className="part-details">
      <div className="detail-row">
        <div className="detail-group">
          <label className="detail-label">Ordered by</label>
          <span className="detail-value">
            {partData.CreatedBy ? partData.CreatedBy : <span className="empty-value">--</span>}
          </span>
        </div>
        <div className="detail-group">
          <label className="detail-label">IPC</label>
          <span className="detail-value">
            {partData.IPC ? partData.IPC : <span className="empty-value">--</span>}
          </span>
        </div>
        <div className="detail-group">
          <label className="detail-label">Flt</label>
          <span className="detail-value">
            {partData.Flt ? partData.Flt : <span className="empty-value">--</span>}
          </span>
        </div>
        <div className="detail-group">
          <label className="detail-label">Part comment</label>
          <span className="detail-value">
            {partData.PartComment ? partData.PartComment : <span className="empty-value">--</span>}
          </span>
        </div>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default Part;
